import * as angular from 'angular';

export class Controller {

    /** @ngInject */
    constructor(Alert, ApplicationsResource) {
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    $onInit() {
        this.ApplicationsResource
            .getApplicationSamlAssertionAttributes(this.companyId, this.application.id)
            .then(attribs => {
                this.$attribs = angular.copy(attribs);
                this.attribs = angular.copy(attribs);
            });

        this.types = [
            {value: 'Custom', label: '[Custom Value]'},
            {value: 'Username', label: 'Account.Username'},
            {value: 'FirstName', label: 'Account.FirstName'},
            {value: 'LastName', label: 'Account.LastName'},
            {value: 'Email', label: 'Account.Email'},
            {value: 'PhoneNumber', label: 'Account.PhoneNumber'},
            {value: 'City', label: 'Account.City'},
            {value: 'Country', label: 'Account.Country'},
            {value: 'StreetAddress', label: 'Account.StreetAddress'},
            {value: 'Department', label: 'Account.Department'},
            {value: 'JobTitle', label: 'Account.JobTitle'},
            {value: 'CompanyName', label: 'Account.CompanyName'},
            {value: 'ZipCode', label: 'Account.ZipCode'},
        ];
    }

    add() {
        this.attribs.push({name: '', type: 'FirstName', customValue: ''})
    }

    notModified() {
        return angular.equals(this.attribs, this.$attribs);
    }

    remove(attrib) {
        this.attribs = this.attribs.filter(a => a !== attrib);
    }

    reset() {
        this.attribs = angular.copy(this.$attribs);
    }

    save() {
        this.isSaving = true;
        this.ApplicationsResource
            .updateApplicationSamlAssertionAttributes(
                this.companyId,
                this.application.id,
                this.attribs,
            )
            .then(() => {
                this.$attribs = angular.copy(this.attribs);
                this.Alert('success', 'company.manage-application.users.customize-saml-assertion.saved');
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/customize-saml-assertion/customize-saml-assertion.controller.js